import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import Loader from "../components/Loader";
import { SEO } from "../components/SEO";
import useLogin from "../hooks/useLogin";

const Login = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, loading, error, success } = useLogin();
  const navigate = useNavigate();

  const from = location.state?.from?.pathname || "/dashboard";

  async function loginUser(e) {
    e.preventDefault();
    await login(email, password);
  }

  useEffect(() => {
    success && navigate(from, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, navigate]);

  return (
    <>
      <SEO
        canonical="/login"
        title="Algoo Strategies - Login"
        description="Algoo Strategies offers this algorithmic trading strategy and
                other asset management tools through a decentralized
                organization, as all their projects run on the ERC-20
                block-chain."
      />
      <div>
        <div className="bg-[#0a0c0f] min-h-screen w-full px-8 pt-36 md:pt-0 md:flex justify-center items-center">
          <div>
            <Loader />
          </div>
          <div>
            <div>
              <Link to="/">
                <img className="w-[20%] mb-14 mx-auto" src={logo} alt="logo" />
              </Link>
            </div>
            <div className="md:w-[500px] fadeIn">
              <div className="text-center text-gray-400 mb-9">
                <h1 className="font-medium text-3xl mb-2">Welcome back</h1>
                <p>Enter your credentials to access your account.</p>
              </div>
              <div>
                <form className="space-y-5" onSubmit={(e) => loginUser(e)}>
                  <div>
                    <label
                      htmlFor="email"
                      className="mb-2 text-sm font-medium text-gray-400 block "
                    >
                      Email
                    </label>
                    <input
                      className="w-full bg-gray-500 border text-gray-300 border-gray-700 rounded-md px-4 py-2 outline-none"
                      name="email"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="mb-2 text-sm font-medium text-gray-400 block "
                    >
                      Password
                    </label>
                    <input
                      className="w-full bg-gray-500 border text-gray-300 border-gray-700 rounded-md px-4 py-2 outline-none"
                      name="password"
                      required
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div>
                    <button
                      disabled={loading}
                      className="w-full disabled:cursor-not-allowed bg-[#b2ffce] rounded-md px-4 py-2 outline-none"
                      type="submit"
                    >
                      {loading ? (
                        <CircularProgress color="inherit" size="25px" />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
                <p className="text-gray-400 text-center mt-3">
                  Don't have an account?{" "}
                  <Link to="/signup" className="text-[#b2ffce] underline">
                    Signup
                  </Link>
                </p>
                <p className="text-gray-400 text-center mt-2">
                  Forgot your password?{" "}
                  <Link to="/login-twofa" className="text-[#b2ffce] underline">
                    Signin with Two-FA
                  </Link>
                </p>
              </div>
            </div>
            <div>
              <p
                onClick={() => navigate("/")}
                className="underline text-gray-400 text-sm mt-8 hover:cursor-pointer"
              >
                Go home
              </p>
            </div>
            <div>
              {success === true && (
                <Snackbar open={true} autoHideDuration={5000}>
                  <Alert severity="success">
                    Login Success! You will be redirected to the dashboard soon.
                  </Alert>
                </Snackbar>
              )}
              {error && (
                <Snackbar open={true} autoHideDuration={5000}>
                  <Alert severity="error">{error}</Alert>
                </Snackbar>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
